import React, { useEffect, useState } from "react";
import { useTexture } from "@react-three/drei";
import { DoubleSide } from "three";
import { a, useSpring } from "@react-spring/three";
import { addEventListener } from "../src/events/eventBus";

export default function SignPlane({
  position = [0, 0, 0],
  rotation = [0, 0, 0],
  size = [4, 2],
  initialScale = 0,
  targetScale = 1,
  duration = 0.5,
}) {
  const texture = useTexture("/img/sign.png");

  const [active, setActive] = useState(false);

  const springs = useSpring({
    scale: active ? [targetScale, targetScale, targetScale] : [initialScale, initialScale, initialScale],
    config: { duration: duration * 1000 },
  });

  useEffect(() => {
    const unsubscribe = addEventListener("playCake", () => {
      setActive(true);
    });

    return () => unsubscribe();
  }, []);

  return (
    <a.mesh position={position} rotation={rotation} scale={springs.scale} userData={{ name: "SignPlane" }}>
      <planeGeometry args={size} />
      <meshBasicMaterial map={texture} transparent side={DoubleSide} />
    </a.mesh>
  );
}
